export default __webpack_public_path__ + "static/media/team23.9fc75d47.JPG";